import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import KycRequested from "../../../kyc/KycRequested";
import { GetAllKycByIdApi } from "../../../../api/request/kyc";
import KycForm from "../../components/KycForm";
import KycVerified from "../../../kyc/KycVerified";

const EKYC = ({
  onNext,
  onPrevious,
  userId,
  isSubmitted,
  onKycPendingChange,
  canUpdate = true,
}) => {
  const [pending, setPending] = useState(false);
  const [kycDetails, setKycDetails] = useState({});
  const [isKycLoading, setIsKycLoading] = useState(true);

  const getKycById = async () => {
    try {
      setIsKycLoading(true);
      const { data } = await GetAllKycByIdApi(userId);
      setKycDetails(data?.data);
      if (data?.data?.kycStatus === "Pending") {
        setPending(true);
        onKycPendingChange?.(true);
      }
      if (data?.data?.kycStatus === "Rejected") {
        setPending(false);
        onKycPendingChange?.(false);
      }
      setIsKycLoading(false);
    } catch (error) {
      setIsKycLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      getKycById();
    }
  }, [userId]);

  useEffect(() => {
    if (kycDetails?.kycStatus === "Pending") {
      setPending(true);
    }
  }, [kycDetails?.kycStatus]);

  const handleKycSubmitted = async () => {
    setPending(true);
    onKycPendingChange?.(true);
    await getKycById();
  };

  const renderNavigation = () => (
    <div className="flex justify-end gap-4 mt-6 px-6 pb-6">
      {onPrevious && (
        <Button onClick={onPrevious} size="large">
          Previous
        </Button>
      )}
      <Button type="primary" onClick={onNext} size="large" className="bg-primary themeHover">
        Next
      </Button>
    </div>
  );

  const renderKycContent = () => {
    if (isKycLoading) {
      return (
        <div className="flex justify-center flex-col my-[8%]">
          <Spin size="large" />
          <p className="primary text-center mt-2">Loading...</p>
        </div>
      );
    }
    if (pending) {
      return <KycRequested setPending={setPending} kycDetails={kycDetails} />;
    }
    if (kycDetails?.kycStatus === "Approved") {
      return <KycVerified kycDetails={kycDetails} />;
    }
    if (!canUpdate) {
      return (
        <div
          className="corporate-review-readonly"
          onSubmitCapture={(event) => event.preventDefault()}
          onKeyDown={(event) => event.preventDefault()}
        >
          <KycForm userId={userId} onSuccess={handleKycSubmitted} />
        </div>
      );
    }
    return <KycForm userId={userId} onSuccess={handleKycSubmitted} />;
  };

  return (
    <div className="w-full">
      {renderKycContent()}
      {!canUpdate && !isKycLoading && renderNavigation()}
      {canUpdate && kycDetails?.kycStatus === "Approved" && !pending && !isKycLoading && (
        <div className="flex justify-end gap-4 mt-6 px-6 pb-6">
          {onPrevious && (
            <Button
              onClick={onPrevious}
              size="large"
              disabled={isSubmitted}
              className="corporate-review-nav"
            >
              Previous
            </Button>
          )}
          <Button
            type="primary"
            onClick={onNext}
            size="large"
            disabled={isSubmitted}
            className="bg-primary themeHover"
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default EKYC;
